import { Card, Col, Row, Skeleton, Typography } from "antd";
import {
  ClockCircleOutlined,
  SyncOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  MailOutlined,
  ReloadOutlined,
  StopOutlined,
  FormOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

const applicationCards = [
  {
    key: "pending",
    label: "Pending",
    icon: <ClockCircleOutlined />,
    color: "#1677ff",
    bg: "#e6f4ff",
  },
  {
    key: "inProgress",
    label: "In Progress",
    icon: <SyncOutlined />,
    color: "#722ed1",
    bg: "#f9f0ff",
  },
  {
    key: "openQuotes",
    label: "Open Quotes",
    icon: <FileTextOutlined />,
    color: "#fa8c16",
    bg: "#fff7e6",
  },
  {
    key: "applicationsTouchedPercentage",
    label: "Touched",
    icon: <CheckCircleOutlined />,
    color: "#52c41a",
    bg: "#f6ffed",
    isPercentage: true,
  },
];

const renewalCards = [
  {
    key: "renewalsExpiring30d",
    label: "Expiring (30d)",
    icon: <WarningOutlined />,
    color: "#fa541c",
    bg: "#fff2e8",
  },
  {
    key: "notSentRenewals",
    label: "Not Sent",
    icon: <MailOutlined />,
    color: "#eb2f96",
    bg: "#fff0f6",
  },
  {
    key: "renewalsExpired",
    label: "Expired",
    icon: <StopOutlined />,
    color: "#cf1322",
    bg: "#fff1f0",
  },
  {
    key: "pendingSentRenewals",
    label: "Pending Completion",
    icon: <FormOutlined />,
    color: "#d48806",
    bg: "#fffbe6",
  },
];

const formatValue = (item, focus) => {
  const val = focus?.[item.key] ?? 0;
  if (item.isPercentage) return `${(val * 100).toFixed(0)}%`;
  return `${val} txn`;
};

const FocusCard = ({ item, focus }) => (
  <Card className="focus-card" style={{ height: 100 }}>
    <div className="focus-card-header">
      <div
        className="focus-icon"
        style={{ color: item.color, background: item.bg }}
      >
        {item.icon}
      </div>
      <Text className="focus-card-label">{item.label}</Text>
    </div>
    <div className="focus-value">{formatValue(item, focus)}</div>
  </Card>
);

const CardGrid = ({ cards, focus }) => (
  <Row gutter={[12, 12]}>
    {cards.map((c) => (
      <Col xs={24} sm={12} xl={12} xxl={6} key={c.key}>
        <FocusCard item={c} focus={focus} />
      </Col>
    ))}
  </Row>
);

const FocusCards = ({ focus, loading }) => {
  if (loading) {
    return (
      <Row
        gutter={[16, 16]}
        justify="space-between"
        style={{ marginLeft: 8, marginRight: 8, marginTop: 16 }}
      >
        <Col xs={24} lg={12}>
          <Card>
            <Skeleton active paragraph={{ rows: 4 }} title={{ width: 120 }} />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card>
            <Skeleton active paragraph={{ rows: 4 }} title={{ width: 100 }} />
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row
      gutter={[16, 16]}
      justify="space-between"
      style={{ marginLeft: 8, marginRight: 8, marginTop: 16 }}
    >
      {/* Applications group */}
      <Col xs={24} lg={12}>
        <Card style={{ width: "100%" }}>
          <div className="focus-group-header">
            <FileTextOutlined
              style={{
                fontSize: 16,
                color: "black",
                marginRight: 10,
                padding: 6,
                background: "#f1f1f1",
                borderRadius: "50%",
              }}
            />
            <Title level={5} style={{ margin: 0 }}>
              Applications
            </Title>
          </div>
          <CardGrid cards={applicationCards} focus={focus} />
        </Card>
      </Col>

      {/* Renewals group */}
      <Col xs={24} lg={12}>
        <Card style={{ width: "100%" }}>
          <div className="focus-group-header">
            <ReloadOutlined
              style={{
                fontSize: 16,
                color: "black",
                marginRight: 10,
                padding: 6,
                background: "#f1f1f1",
                borderRadius: "50%",
              }}
            />
            <Title level={5} style={{ margin: 0 }}>
              Renewals
            </Title>
          </div>
          <CardGrid cards={renewalCards} focus={focus} />
        </Card>
      </Col>
    </Row>
  );
};

export default FocusCards;
